/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { useCallback, useState } from 'react';
import type { SwotCategory, SectionType } from '@g17eco/types/insights-synthesis';

export interface InsightsFilter {
  pillar: 'all' | SectionType;
  swot: 'all' | SwotCategory;
}

const DEFAULT_FILTERS: InsightsFilter = {
  pillar: 'all',
  swot: 'all',
};

export const useInsightsFilters = (defaultValue?: Partial<InsightsFilter>) => {
  const [filters, setFiltersState] = useState<InsightsFilter>({
    ...DEFAULT_FILTERS,
    ...defaultValue,
  });

  const setFilters = useCallback((update: Partial<InsightsFilter>) => {
    setFiltersState((prev) => ({ ...prev, ...update }));
  }, []);

  const resetFilters = useCallback(() => {
    setFiltersState(DEFAULT_FILTERS);
  }, []);

  return { filters, setFilters, resetFilters };
};
